import Vue from 'vue'

Vue.directive('clipboard', {
  bind(el) {
    el.style.cursor = 'pointer'

    el._clipboardHandler = async () => {
      const text = el.innerText.trim()
      if (!text) return

      try {
        await navigator.clipboard.writeText(text)
        Vue.prototype.$toast?.success('Conteúdo Copiado!', { timeout: 1500 })
      } catch {
        // Fallback para navegadores sem suporte a clipboard API
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Vue.prototype.$toast?.success('Conteúdo Copiado!', { timeout: 1500 })
      }
    }

    el.addEventListener('click', el._clipboardHandler)
  },
  unbind(el) {
    el.removeEventListener('click', el._clipboardHandler)
    delete el._clipboardHandler
  }
})
